import { createItemFormFields } from '@routable/shared';
import {} from 'redux';
import {} from 'interfaces/attachment';
import { formActionsCreateItem } from './forms';
export const handleUpdateBillViewAttachments = (itemAttachments) => formActionsCreateItem.change(createItemFormFields.ITEM_BILLS, itemAttachments);
export const removeCreateItemBill = (index, field = createItemFormFields.ITEM_BILLS) => formActionsCreateItem.arraySplice(field, index, 1);
